import React from 'react';
import { useHistory, useParams } from 'react-router';
import _TopRight from 'src/layout/EditorPageLayout/TopRightBtnsGroups/TopRightBtnsGroups';

const TopRight = (props) => {
  const { hasModified, onSubmit, disableEdit } = props;
  const { uuid }: any = useParams();

  const h = useHistory();
  const onD = () => {
    h.push(`/salesChannel/settings/${uuid}`);
  };
  return (
    <_TopRight
      onDiscard={onD}
      onSaveDisable={!hasModified || disableEdit}
      onSubmit={onSubmit}
    />
  );
};
export default TopRight;
